import 'chart.js/auto';
import * as LogRocket from 'logrocket';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.logRocketAppId) {
  LogRocket.init(environment.logRocketAppId);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
